export default "__VITE_ASSET__2f03d885__"